import { useEffect, useState } from 'react'
import { GeneralAPI } from '../apis/GeneralAPI'
import BreadCrumbs from '../components/Breadcrumbs'
import { Container } from '../components/Container'
import Header from '../components/Header'
import Loader from '../components/Loader'
import CartComponent from '../components/Product/CartComponent'
import InfoAlert from '../components/Alerts/InfoAlert'
import {
    _isLoggedIn,
    formatCurrency,
    getErrorMessage,
    getTotalStoreCredits,
    log,
    reloadCart,
} from '../helpers/utils'
import { getCartFromWordPress } from '../helpers/cart'
import { UserAPI } from '../apis/UserAPI'

/**
 * @ISSUES
 * it does not refresh when removed
 */

/**
 * so first customer will add items to cart, we will have line items ids (add on items ids too), when they click on checkout
 * It will go to next checkout page, since we have hash on those cart items on checkout page, we can show them on checkout page
 * Now when they click on checkout button on cart page, using those item ids we actually create a duplicate order in backend.
 * using draft order of whole order, Now in order to create this draft order, we just need to call, CartAPI.getCheckout().
 * On checkout page, we can have that order id in query string and may be fetch line items from that order id and apply coupon
 * anything like that right there using custom endpoints.
 * And when they checkout we simple checkout for that order, update its payment and everything.
 * And then remove those items hash, we have them, from cart.
 * then rework files to have new order ids, using AWS API and CSV tool (on frontend.)
 * So in nutshell, these are the steps
 * 1. Add items to cart - done
 * 2. Click on checkout - done
 * 3. Create draft order - done
 * 4. Duplicate order for just those line item ids - done
 * 5. Apply coupon or anything on that order - not done
 * 6. Checkout that order - - done
 * 7. Remove those items from cart - done
 * 8. Rework files to have new order ids
 */

const pages = [{ name: 'Cart', href: '/cart', current: true }]

export default function Cart({ data }) {
    const meta = data.yoast_head

    const [cart, setCart] = useState(data.cart)

    const [loading, setLoading] = useState(true)

    const handleCart = (updatedCart) => {
        setCart(updatedCart)
        reloadCart(updatedCart)
        setLoading(false)
    }

    useEffect(() => {
        setCart(data.cart)
        setLoading(false)
        return () => {}
    }, [])

    const [totalStoreCredits, setTotalStoreCredits] = useState(0)

    const handleUserCoupons = async () => {
        try {
            const coupons = await UserAPI.getStoreCredits()
            setTotalStoreCredits(getTotalStoreCredits(coupons))
        } catch (e) {
            log(getErrorMessage(e))
        }
    }

    useEffect(() => {
        if (_isLoggedIn()) handleUserCoupons()
    }, [_isLoggedIn()])

    return (
        <div data-page-id="cart">
            {loading && <Loader text={'Cart Loading...'} />}
            <Header meta={meta} title="Cart" />
            <BreadCrumbs list={pages} />
            <Container>
                <div className="relative">
                    <div className="pb-10">
                        {totalStoreCredits > 0 && (
                            <InfoAlert>
                                <b>
                                    You have{' '}
                                    {formatCurrency(totalStoreCredits, 2)} in
                                    store credit.
                                </b>{' '}
                                Access your credits during checkout.
                            </InfoAlert>
                        )}
                    </div>
                    <CartComponent {...{ cart, handleCart }} />
                </div>
            </Container>
        </div>
    )
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getServerSideProps({ req }) {
    const page = await GeneralAPI.getPageBySlug('/cart')
    let data = page ? page[0] : {}

    data.cart = await getCartFromWordPress({ req })

    return {
        props: {
            data,
        },
    }
}
